// @todo: Migrate to 'Select' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Select} from '@wandb/weave/components/Form/Select';
import React, {useRef, useState} from 'react';

import {TeamMemberRole} from '../TeamMembersTable/utils';
import {
  customSelectComponentForRoleOptions,
  RoleOption,
  TeamOrOrganizationRoleOption,
} from '../TeamOrOrganizationRoleOption';
import {OrganizationMemberRole} from '../util';

type Props = {
  roleOptions: RoleOption[];
  role: string;
  setRole: (role: OrganizationMemberRole | TeamMemberRole) => void;
};

// todo(sammy): we should use generics, since the role we want is either Organization/Team/User Role.
export const RoleDropdown = ({roleOptions, role, setRole}: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  return (
    <Select<RoleOption, false>
      menuIsOpen={isOpen}
      onMenuOpen={() => setIsOpen(true)}
      onMenuClose={() => setIsOpen(false)}
      options={roleOptions}
      formatOptionLabel={option => (
        <TeamOrOrganizationRoleOption roleOption={option} />
      )}
      value={roleOptions.find(option => option.value === role)}
      onChange={selected => {
        if (selected?.value && !selected?.isDisabled) {
          setRole(selected.value as OrganizationMemberRole | TeamMemberRole);
        }
      }}
      components={customSelectComponentForRoleOptions(true)}
      menuPortalTarget={ref.current}
      menuPosition="fixed"
      isSearchable={false}
      isLoading={false}
      classNamePrefix="invite-role-dropdown-trigger"
      blurInputOnSelect
    />
  );
};
